import { createStore } from "lib/store";
import { createContext } from "react";

export const defaultFormContext = {
    name: "",
    onSubmit: [],
    onChange: [],
    alwaysValidate: false,
    submitting: false,
    submitted: false,
    error: "",
    values: {},
    errors: {},
    rules: {}
};
export const FormContext = createContext(createStore(defaultFormContext));
FormContext.displayName = "FormContext";
